// 修改SKU
import addSku from './addSku'
// 修改SKU
import editSku from './editSku'
//修改所有sku
import editSkuAll from './editSkuAll'
// 编辑SPU
import editSpu from './editSpu'
// 编辑产品
import editProduct from './editProduct'
// 到货
import arrival from './arrival'
import ConfirmArrival from './confirm-arrival'
// 拍摄计划
import photography from './photography'
// 工作计划
import workPlan from './workPlan'
// 页面计划
import pagePlan from './page-plan'
// 渲染计划
import renderingSchedule from './rendering-schedule.vue'
// 确认完成
import completeTask from './complete-task'
// 确认组货
import groupGoods from './groupGoods'
// 产品资料
import productInfomation from './productInfomation/productInfomation'
// 产品文案
import productPaperwork from './productPaperwork'
// 页面计划
import design from './design'
// 备注
import remark from './remark'
// 修片上传
import retouchImport from './retouchImport'
// 渲染上传
import renderingImport from './renderingImport'
// 切片上传
import sectionImport from './sectionImport'
// 回退节点
import fallbackNode from './fallbackNode'

// 删除spu
import delSpuMixin from './delSpu.mixin'
// 删除sku
import delSkuMixin from './delSku.mixin'
// 刷新
import refreshMixin from './refresh.mixin'
// 上架
import publishMixin from './publish.mixin'
// 开始拍摄，设计，切片
import startTaskMixin from './start-task.mixin'
// 开始修片
import retouchStartMixin from './retouchStart.mixin'
// 终止
import switchStateMixin from './switchState.mixin'
// 关联产品详情
import RelatedProductDetail from './related-product-detail.vue'
// 关联产品详情
import batchProcessing from './batch-processing.vue'
// 批量渲染
import renderBatchProcessing from './render-batch-processing.vue'
// 拍摄类型
import hootingType from './hootingType.vue'
// 上架失败列表
import failedList from './failedList.vue'
// 删除spu
import jumpMixin from './jump.mixin'
export default {
  mixins: [delSpuMixin, delSkuMixin, refreshMixin, publishMixin, retouchStartMixin, switchStateMixin, startTaskMixin, jumpMixin],
  components: {
    addSku,
    editSku,
    editSpu,
    editProduct,
    arrival,
    ConfirmArrival,
    groupGoods,
    photography,
    renderingSchedule,
    workPlan,
    pagePlan,
    productInfomation,
    productPaperwork,
    design,
    completeTask,
    RelatedProductDetail,
    batchProcessing,
    renderBatchProcessing,
    remark,
    editSkuAll,
    hootingType,
    retouchImport,
    renderingImport,
    fallbackNode,
    sectionImport,
    failedList
  },
  data() {
    return {
      skuVisible: false,
      skuVisible2: false,
      skuVisibleAll: false,
      spuVisible: false,
      editProductVisible: false,
      editProductData: null,
      arrivalVisible: false,
      confirmArrivalVisible: false,
      groupGoodsVisible: false,
      photographyVisible: false,
      renderingVisible: false,
      workPlanVisible: false,
      pagePlanVisible: false,
      productInfomationVisible: false,
      productPaperworkVisible: false,
      designVisible: false,
      completeTaskVisible: false,
      relatedDetailVisible: false,
      batchProcessingVisible: false,
      renderBatchProcessingVisible: false,
      remarkVisible: false,
      renderShow: false,
      hootingTypeVisible: false,
      retouchImportVisible: false,
      renderingImportVisible: false,
      fallbackNodeVisible: false,
      sectionVisible: false,
      failedListVisible: false,
      processType: 0,
    }
  },
  methods: {
    addSkuShow() {
      this.skuVisible2 = true;
    },
    editSkuShow(skuCode) {
      this.skuCode = skuCode;
      this.skuVisible = true;
    },
    editSputAllShow(skuCode) {
      this.skuCode = skuCode;
      this.skuVisibleAll = true;
    },
    editSpuShow() {
      this.spuVisible = true;
    },
    editProductShow(row, skuInfo) {
      let { productCode, productName } = row
      this.editProductData = {
        productCode,
        productName,
        spuId: skuInfo.spuId,
        skuId: skuInfo.dataId,
      };
      this.editProductVisible = true;
    },
    deleteProduct(row, skuInfo) {
      this.$confirm(
        '确定是否删除此产品？删除后系统内所有关于此产品的新品数据都会同步删除？',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        const params = {
          productCode: row.productCode,
          spuId: skuInfo.spuId,
          skuId: skuInfo.dataId,
        }
        this.$q.newProduct.deleteProductCode({ data: params })
          .then(({ success }) => {
            if (success) {
              this.$notify.success({
                title: '成功',
                message: '删除产品成功',
              });
              this.updateSkuList();
            }
          })
          .catch(console.log);
      }).catch(() => {
      });
    },
    fallbackNodeShow() {
      this.fallbackNodeVisible = true
    },
    sectionShow() {
      this.sectionVisible = true
    },
    hootingTypeShow() {
      this.hootingTypeVisible = true;
    },
    arrivalShow(skuId, skuCode) {
      this.skuId = skuId;
      this.skuCode = skuCode;
      this.arrivalVisible = true;
    },
    showConfirmArrival(skuId, skuCode) {
      this.skuId = skuId;
      this.skuCode = skuCode;
      this.confirmArrivalVisible = true;
    },
    groupGoodsShow() {
      this.groupGoodsVisible = true;
    },
    photographyShow() {
      this.photographyVisible = true;
    },
    renderingShow() {
      this.renderingVisible = true;
    },
    workPlanShow() {
      this.workPlanVisible = true;
    },
    showPagePlan() {
      this.pagePlanVisible = true;
    },
    photographyCompleteShow() {
      this.photographyCompleteVisible = true;
    },
    productInfomationShow() {
      window.open('https://uip.quanyou.com.cn/login?redirect=%2Findex', '_blank')
      // this.productInfomationVisible = true;
    },
    remarkShow() {
      this.remarkVisible = true;
    },
    productPaperworkShow() {
      this.productPaperworkVisible = true;
      // let data = {
      //   spuId: this.spuId,
      //   type: '5'
      // }
      // this.$q.newProduct.queryProductDataCopywriting({params: data})
      // .then(res=>{
      //   if(res.data && res.data.length) {
      //     this.productPaperworkVisible = true;
      //   }else{
      //     this.$alert('请先提交\'产品资料\'，再上传\'产品文案\'', '提示')
      //   }
      // })

    },
    designShow() {
      this.designVisible = true;
    },
    batchProcessingShow() {
      this.batchProcessingVisible = true;
    },
    renderBatchProcessingShow() {
      this.renderBatchProcessingVisible = true;
    },
    showCompleteTask(skuId, skuCode, taskId, retouchingSpuId, renderShow) {
      this.skuId = skuId;
      this.skuCode = skuCode;
      this.taskId = taskId;
      this.retouchingSpuId = retouchingSpuId;
      this.renderShow = renderShow;
      this.completeTaskVisible = true;
    },
    showProductDetail(productCode, productName) {
      this.productCode = productCode;
      this.productName = productName;
      this.relatedDetailVisible = true;
    },
    getFailedList(val) {
      this.failedSkuId = val
      this.failedListVisible = true
    },
  },
  mounted() {
    // this.designShow();
  }
}